var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 6.5H7.5V6V3C7.5 2.86739 7.55268 2.74021 7.64645 2.64645C7.74021 2.55268 7.86739 2.5 8 2.5H20C20.1326 2.5 20.2598 2.55268 20.3536 2.64645C20.4473 2.74021 20.5 2.86739 20.5 3V17C20.5 17.1326 20.4473 17.2598 20.3536 17.3536C20.2598 17.4473 20.1326 17.5 20 17.5H17H16.5V18V21C16.5 21.2729 16.2768 21.5 15.993 21.5L4.007 21.5L4.00401 21.5C3.938 21.5004 3.87257 21.4878 3.81147 21.4628C3.75037 21.4378 3.69481 21.401 3.64798 21.3545C3.60114 21.308 3.56396 21.2527 3.53856 21.1918C3.5132 21.1309 3.5001 21.0657 3.5 20.9998L3.503 7.00011V7C3.503 6.72706 3.72622 6.5 4.01 6.5H7ZM5.003 7.5H4.50312L4.503 7.99988L4.5 19.9999L4.49987 20.5H5H15H15.5V20V8V7.5H15H5.003ZM8.5 6V6.5H9H16.5V16V16.5H17H19H19.5V16V4V3.5H19H9H8.5V4V6Z",
    fill: "#09121F",
    stroke: "#3286DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.266389a899ee2aa9a77c73f7500be61f.svg";
export { ForwardRef as ReactComponent };